/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import coronaInfoStyles from "./coronaInfoStyles";
import ContainerFullWidth from "../Container/ContainerFullWidth";
import Grid from "@mui/material/Grid";
import HelpIcon from "../../assets/icons/generic/IconHelp";
import Typography from "@mui/material/Typography";

const CoronaInfo = () => {
  return (
    <ContainerFullWidth>
      <Grid
        container
        sx={[{
          alignItems: "center"
        }, coronaInfoStyles.container]}>
        <Grid
          size={{
            xs: 12,
            sm: 1
          }}>
          <HelpIcon sx={coronaInfoStyles.helpIcon} />
        </Grid>
        <Grid
          sx={coronaInfoStyles.textContainer}
          size={{
            xs: 12,
            sm: 11
          }}>
          <Typography variant={"h4"} sx={coronaInfoStyles.header}>
            Legalbird hilft Ihnen auch während der Corona-Krise
          </Typography>
          <p>
            Besonders in der aktuellen Situation können Sie sicher sein, dass wir Ihnen jederzeit weiterhelfen und uns professionell um Ihre Rechtsthemen
            kümmern. Als Online-Kanzlei sind wir wie gewohnt per Telefon und E-Mail in vollem Serviceumfang für Sie da.
          </p>
        </Grid>
      </Grid>
    </ContainerFullWidth>
  );
};

export default CoronaInfo;
